module.exports = __webpack_public_path__ + "img/img_card@2x.88b87944.png";